module.exports = __webpack_public_path__ + "static/media/siren.98c85eb4.svg";